package com.eladfinish.bible.contest.ui.components.toolbar.configuration.model

sealed interface ToolbarNavigationMode {

    data object Unspecified : ToolbarNavigationMode

    data object None : ToolbarNavigationMode

    data class NavigationButton(
        val config: ToolbarNavigationButtonConfig?,
    ) : ToolbarNavigationMode
}
